(() => {
  const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, ch => ({
    '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
  }[ch]));

  document.querySelectorAll('.mobile-comparison[data-section-id]').forEach(section => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const input = section.querySelector('.mobile-comparison__search-input');
    const results = section.querySelector('.mobile-comparison__search-results');
    const slots = section.querySelector('.mobile-comparison__selected-phones');
    const compareBtn = section.querySelector('.mobile-comparison__compare-btn');
    const output = section.querySelector('.mobile-comparison__comparison-section');
    const error = section.querySelector('.error-message');
    const typeIndicator = section.querySelector('[id^="typeIndicator-"]');
    const products = Object.values(window.comparisonProducts || {});
    const selected = [];
    let selectedType = null;
    const maxProducts = 3;

    const showError = message => {
      error.textContent = message;
      error.style.display = 'block';
      window.setTimeout(() => { error.style.display = 'none'; }, 3200);
    };

    const getSpecs = product => product.specs && typeof product.specs === 'object' ? product.specs : {};
    const getCategory = (specs, category) => {
      const key = Object.keys(specs).find(k => k.trim().toLowerCase() === category.trim().toLowerCase());
      const value = key ? specs[key] : null;
      return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
    };

    const formatValue = value => {
      if (value === null || value === undefined || value === '') return '—';
      if (typeof value === 'boolean') return value ? 'Yes' : 'No';
      if (Array.isArray(value)) return value.map(v => typeof v === 'object' ? Object.values(v).join(' ') : String(v)).join(', ');
      if (typeof value === 'object') return Object.values(value).filter(v => v !== null && v !== '').map(v => String(v)).join(', ') || '—';
      return String(value);
    };

    const updateType = () => {
      input.placeholder = selectedType ? 'Search for a ' + selectedType.toLowerCase() + '...' : 'Search for a product...';
      typeIndicator.innerHTML = '';
    };

    const updateButton = () => {
      compareBtn.disabled = selected.length < 2;
      compareBtn.textContent = selected.length < 2 ? 'Select at least 2 products' : 'Compare ' + selected.length + ' Products';
    };

    const renderSlots = () => {
      const slotEls = slots.querySelectorAll('.mobile-comparison__phone-slot');
      slotEls.forEach((slot, index) => {
        const p = selected[index];
        slot.classList.toggle('filled', !!p);
        if (!p) {
          slot.innerHTML = '<span>Click to add product</span><span style="font-size:13px;color:#999;">or search above</span>';
          slot.onclick = () => input.focus();
          return;
        }
        slot.onclick = null;
        slot.innerHTML = '<img class="mobile-comparison__phone-slot-image" src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.name) + '">' +
          '<div class="mobile-comparison__phone-slot-name">' + escapeHtml(p.name) + '</div>' +
          '<div style="margin-bottom:10px;color:#666;">' + escapeHtml(p.brand) + '</div>' +
          '<div style="margin-bottom:10px;color:#999;font-size:.8rem;">' + escapeHtml(p.type) + '</div>' +
          '<button type="button" class="mobile-comparison__phone-slot-remove" data-index="' + index + '">Remove</button>';
      });
      updateButton();
    };

    const addProduct = handle => {
      if (selected.length >= maxProducts) return showError('Maximum 3 products allowed');
      if (selected.some(p => p.handle === handle)) return showError('Product already selected');
      const p = (window.comparisonProducts || {})[handle];
      if (!p) return showError('Product not found');
      const type = (p.type || 'Uncategorized').trim().toLowerCase();
      if (selectedType && type !== selectedType.toLowerCase()) return showError('You can only compare products of the same type.');
      if (!selectedType) {
        selectedType = p.type || 'Uncategorized';
        updateType();
      }
      selected.push({handle:p.handle,name:p.title,brand:p.vendor,type:p.type,image:p.image,price:p.price,specs:getSpecs(p)});
      renderSlots();
    };

    const renderSearch = query => {
      const term = query.trim().toLowerCase();
      if (term.length < 2) { results.classList.remove('active'); return; }
      const found = products.filter(p =>
        ((p.title || '').toLowerCase().includes(term) || (p.vendor || '').toLowerCase().includes(term)) &&
        (!selectedType || (p.type || '').trim().toLowerCase() === selectedType.toLowerCase())
      ).slice(0,10);

      if (!found.length) {
        results.innerHTML = '<div class="no-results">No products found matching "' + escapeHtml(query) + '"</div>';
      } else {
        results.innerHTML = found.map(p =>
          '<div class="mobile-comparison__search-result-item" data-handle="' + escapeHtml(p.handle) + '">' +
          '<img src="' + escapeHtml(p.image || '') + '" class="mobile-comparison__search-result-image" alt="' + escapeHtml(p.title) + '">' +
          '<div class="mobile-comparison__search-result-info"><div class="mobile-comparison__search-result-name">' + escapeHtml(p.title) +
          '</div><div class="mobile-comparison__search-result-brand">' + escapeHtml(p.vendor || '') + (p.type ? ' • ' + escapeHtml(p.type) : '') + '</div></div></div>'
        ).join('');
      }
      results.classList.add('active');
    };

    const renderComparison = () => {
      if (selected.length < 2) return showError('Select at least 2 products');
      let html = '<div class="mobile-comparison__highlights">';
      selected.forEach(p => {
        const specs = getSpecs(p);
        let highlights = Array.isArray(specs.highlights) ? specs.highlights : [];
        if (!highlights.length) {
          const candidates = [
            ['Display', getCategory(specs,'Display')],
            ['Processor', getCategory(specs,'Performance')],
            ['Camera', getCategory(specs,'Camera')],
            ['Battery', getCategory(specs,'Battery')]
          ];
          highlights = candidates.map(([label, obj]) => {
            const value = Object.values(obj)[0];
            return value !== undefined ? {label,value} : null;
          }).filter(Boolean);
        }
        html += '<div class="mobile-comparison__highlight-card"><img src="' + escapeHtml(p.image) +
          '" style="width:120px;margin-bottom:15px;" alt="' + escapeHtml(p.name) + '"><h3>' + escapeHtml(p.name) +
          '</h3><p>' + escapeHtml(p.brand) + '</p><p style="font-size:24px;font-weight:bold;color:#007bff;">' +
          escapeHtml(p.price) + '</p>';
        if (highlights.length) {
          highlights.forEach(h => {
            html += '<div class="mobile-comparison__highlight-item"><span class="mobile-comparison__highlight-label">' +
              escapeHtml(h.label || '') + '</span><span class="mobile-comparison__highlight-value">' +
              escapeHtml(formatValue(h.value)) + '</span></div>';
          });
        } else html += '<p style="color:#666;font-size:16px;">Highlights not available</p>';
        html += '</div>';
      });
      html += '</div>';

      const preferred = ['General','Display','Memory','Performance','Battery','Camera','Connectivity','Other'];
      const categoryMap = new Map();
      selected.forEach(p => Object.keys(getSpecs(p)).forEach(category => {
        const values = getSpecs(p)[category];
        if (category.toLowerCase() !== 'highlights' && values && typeof values === 'object' && !Array.isArray(values)) {
          const normalized = category.trim().toLowerCase();
          if (!categoryMap.has(normalized)) categoryMap.set(normalized, category);
        }
      }));
      const categories = [
        ...preferred.filter(c => categoryMap.has(c.toLowerCase())).map(c => categoryMap.get(c.toLowerCase())),
        ...Array.from(categoryMap.entries()).filter(([k]) => !preferred.some(c => c.toLowerCase() === k)).map(([,v]) => v)
      ];

      categories.forEach(category => {
        const rows = new Map();
        selected.forEach(p => Object.keys(getCategory(getSpecs(p),category)).forEach(key => {
          const normalized = key.trim().toLowerCase();
          if (!rows.has(normalized)) rows.set(normalized,key);
        }));
        if (!rows.size) return;
        html += '<div class="mobile-comparison__specs-table"><div class="mobile-comparison__specs-category">' +
          escapeHtml(category) + '</div><div class="mobile-comparison__specs-grid" style="grid-template-columns:220px repeat(' +
          selected.length + ',1fr);">';
        rows.forEach((label, normalized) => {
          html += '<div class="mobile-comparison__specs-label">' + escapeHtml(label) + '</div>';
          selected.forEach(p => {
            const values = getCategory(getSpecs(p),category);
            const key = Object.keys(values).find(k => k.trim().toLowerCase() === normalized);
            html += '<div class="mobile-comparison__specs-value">' + escapeHtml(formatValue(key ? values[key] : null)) + '</div>';
          });
        });
        html += '</div></div>';
      });

      if (!categories.length) html += '<div class="no-results">No detailed specifications available for comparison</div>';
      output.innerHTML = html;
      output.classList.add('active');
      output.scrollIntoView({behavior:'smooth',block:'start'});
    };

    input.addEventListener('input', () => renderSearch(input.value));
    input.addEventListener('focus', () => renderSearch(input.value));
    results.addEventListener('click', event => {
      const item = event.target.closest('[data-handle]');
      if (!item) return;
      addProduct(item.dataset.handle);
      results.classList.remove('active');
      input.value = '';
    });
    slots.addEventListener('click', event => {
      const button = event.target.closest('.mobile-comparison__phone-slot-remove');
      if (!button) return;
      selected.splice(Number(button.dataset.index),1);
      if (!selected.length) { selectedType = null; updateType(); }
      renderSlots();
      output.classList.remove('active');
      output.innerHTML = '';
    });
    document.addEventListener('click', event => {
      if (!section.contains(event.target)) results.classList.remove('active');
    });
    compareBtn.addEventListener('click', renderComparison);

    renderSlots();
    updateType();
    const params = new URLSearchParams(window.location.search);
    const handle = params.get('product') || sessionStorage.getItem('compare_product');
    if (handle && (window.comparisonProducts || {})[handle]) {
      sessionStorage.removeItem('compare_product');
      addProduct(handle);
    }
  });
})();